import React, { useState } from "react";
import { FaBars, FaTimes, FaGithub, FaLinkedin } from "react-icons/fa";
import Logo from "../assets/logo.jpg";
import { Link } from "react-scroll";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);

  return (
    <div className="fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#0a192f] text-gray-300">
      <div>
        <h3 className="gabrielpaess">gabrielpaess</h3>
      </div>

      {/* menu */}
      <ul className="hidden md:flex">
        <li>
          <Link className="txtNavbar" to="home" smooth={true} duration={500}>
            INICIO
          </Link>
        </li>
        <li>
          <Link className="txtNavbar" to="about" smooth={true} duration={500}>
            SOBRE
          </Link>
        </li>
        <li>
          <Link className="txtNavbar" to="skills" smooth={true} duration={500}>
            HABILIDADES
          </Link>
        </li>
        <li>
          <Link className="txtNavbar" to="work" smooth={true} duration={500}>
            PROJETOS
          </Link>
        </li>
        <li>
          <Link className="txtNavbar" to="contact" smooth={true} duration={500}>
            CONTATO
          </Link>
        </li>
      </ul>

      {/* Hambumber */}
      <div onClick={handleClick} className="md:hidden z-10">
        {!nav ? <FaBars /> : <FaTimes />}
      </div>

      {/* Mobile Menu*/}
      <ul
        className={
          !nav
            ? "hidden"
            : "absolute top-0 left-0 w-full h-screen bg-[#0a192f] flex flex-col justify-center items-center"
        }
      >
        <li className="py-6 text-4xl">
          <Link className="txtNavbar" onClick={handleClick} to="home" smooth={true} duration={500}>
            INICIO
          </Link>
        </li>
        <li className="py-6 text-4xl">
          <Link className="txtNavbar" onClick={handleClick} to="about" smooth={true} duration={500}>
            SOBRE
          </Link>
        </li>
        <li className="py-6 text-4xl">
          <Link className="txtNavbar" onClick={handleClick} to="skills" smooth={true} duration={500}>
            HABILIDADES
          </Link>
        </li>
        <li className="py-6 text-4xl">
          <Link className="txtNavbar" onClick={handleClick} to="work" smooth={true} duration={500}>
            PROJETOS
          </Link>
        </li>
        <li className="py-6 text-4xl">
          <Link className="txtNavbar" onClick={handleClick} to="contact" smooth={true} duration={500}>
            CONTATO
          </Link>
        </li>
      </ul>

      {/*Social Icons*/}
      <div className="hidden lg:flex fixed flex-col top-[35%] left-0">
        <ul>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] pr-[15px] duration-300 bg-blue-600">
            <a
              className="flex justify-between items-center w-full pl-[15px]  text-gray-300"
              href="https://www.linkedin.com/in/gabrielpaess/"
              target="_blank" rel="noreferrer"
            >
              LinkedIn <FaLinkedin size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[0px] pr-[15px]  duration-300 bg-[#333333]">
            <a
              className="flex justify-between items-center w-full pl-[15px] text-gray-300"
              href="https://github.com/gabrielpaess"
              target="_blank" rel="noreferrer"
            >
              GitHub <FaGithub size={30} />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
//9600007553